import { Header as BaseHeader } from "@olmokit/components/Header";
import "./index.scss";

/**
 * Component: Header
 *
 */
export function Header() {
  const header = BaseHeader();

  return {
    /**
     * Set variant
     *
     * @param {"light" | "dark"} variant
     */
    setVariant(variant) {
      const { className } = header.$root;
      header.$root.className = className.replace(
        /(is-).+(\s*)/,
        `$1${variant}$2`
      );
    },
  };
}
